import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PageTitle from "../components/PageTitle";
import PageHeader from "../components/PageHeader";
import __ from "../utils/translator";
import CardTitle from "../components/CardTitle";
import styled, { css, withTheme } from "styled-components";
import thronThumbnail from "../utils/thronThumbnail";
import ProductFocusesStoreActions from "../flux/ProductFocusesStoreActions";
import ProductFocusGroupsStore from "../flux/ProductFocusGroupsStore";
import themeResponsiveProperty from "../components/responsive/themeResponsiveProperty";
import Header from '../components/organisms/Header';
import PatternCardList from '../components/PatternCardList';
import CardsLayoutPattern from '../utils/CardsLayoutPattern';
import Card from '../components/Card';
import ThemeLabelContainer from '../components/theme-card/ThemeLabelContainer';
import ThemeStatusTypes from '../flux/ThemeStatusTypes';
import ThemeCardThemeStatus from '../components/ThemeCardThemeStatus';
import { ThronAssetModal } from 'theme-builder';
import PDFModal from "../components/PDFModal";
import OutletOnlyLabel from "../components/OutletOnlyLabel";
import JwtStore from "../flux/JwtStore";

const PRODUCT_FOCUS_GROUP_STATUS_DRAFT = 'DRAFT';
const PRODUCT_FOCUS_GROUP_STATUS_PUBLISHED = 'PUBLISHED';

const defaultPfGroupsProps = {
  thronModalOpened: false,
  assetClicked: null,
};

class ProductFocusGroups extends Component {

  state = {
    didLoad: false,
    productFocus: ProductFocusGroupsStore.getState(),
    ...defaultPfGroupsProps
  };

  subscriptions = [];

  constructor(props){
    super(props);
    this.onMediaClick = this.onMediaClick.bind(this);
    this.onThronModalCloseButtonClick = this.onThronModalCloseButtonClick.bind(this);
  }
  onThronModalCloseButtonClick(){
    this.setState({ thronModalOpened: false, termAssetClicked: null});
  }

  onMediaClick(asset) {
    ProductFocusesStoreActions.viewContent(asset);
    this.setState({
      thronModalOpened: true,
      assetClicked: asset,
    });
  }

  componentDidMount() {
    ProductFocusesStoreActions.viewProductFocus(this.props.match.params.productFocusId);
    ProductFocusesStoreActions.fetchById(this.props.match.params.productFocusId);
    this.subscriptions.push(ProductFocusGroupsStore.addListener(() => {
      const productFocus = ProductFocusGroupsStore.getState();
      this.setState({
        didLoad: productFocus !== null,
        productFocus,
      });
    }));

  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.productFocusId !== this.props.match.params.productFocusId) {
      ProductFocusesStoreActions.viewProductFocus(this.props.match.params.productFocusId);
      ProductFocusesStoreActions.fetchById(this.props.match.params.productFocusId);
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {

    return (
      <div>
        <Header actions={themeResponsiveProperty(['back', 'search', 'glossary'], undefined)(this.props)} />

        {this.state.didLoad &&  (
          <PageTitle withTracking title={`Product Focus / ${this.state.productFocus.name}`} />
        )}

        <div style={{position: 'relative'}}>
          <PageHeader
            large
            crumbs={[__('Home'), __('Product Focus'), this.state.productFocus.name]}
            backUrl="/product-focuses"
            cover={this.state.productFocus.cover}
            title={this.state.productFocus.name}>
          </PageHeader>
        </div>

        <Container>
          <ContainerInner>
            {this.state.productFocus.productFocusGroups.filter(pfGroup => (
              pfGroup.contents.length > 0
            )).map(pfGroup => (
              <React.Fragment key={pfGroup.id}>
                <SectionTitle as={themeResponsiveProperty('h4', 'h3')(this.props)}>
                  {pfGroup.name}
                </SectionTitle>

                <div style={{
                  paddingRight: themeResponsiveProperty(null, '1rem')(this.props),
                  paddingLeft: themeResponsiveProperty(null, '1rem')(this.props),
                }}>
                  <PatternCardList pattern={CardsLayoutPattern.Grid}>
                    {pfGroup.contents.map(asset => (
                      <Card
                        key={`group:${pfGroup.id}:asset:${asset.id}`}
                        onClick={() => this.onMediaClick(asset)}
                        cover={thronThumbnail(`${asset.pKey}@${asset.contentId}`)}
                        justifyContent="flex-end"
                      >
                        {asset.contentType && asset.contentType.toLowerCase() === 'video' && (
                          <ImageOverlayIcon>
                            <svg viewBox="0 0 26 26" style={{
                              width: '3.25rem',
                              height: '3.25rem',
                            }}>
                              <g fill="none" fillRule="evenodd">
                                <path stroke="#979797" strokeWidth={.5} fillOpacity={.83} fill="#272727" d="M.25.25h25.5v25.5H.25z"/>
                                <path fill="#FFF" d="M16.073 12.934L10.4 17.046V8.82z"/>
                              </g>
                            </svg>
                          </ImageOverlayIcon>
                        )}

                        <ThemeLabelContainer theme={{
                          confidential: pfGroup.status === PRODUCT_FOCUS_GROUP_STATUS_DRAFT,
                          furSpecialist: false,
                        }} />

                        <CardTitle
                          small={themeResponsiveProperty(false, true)(this.props)}
                          style={{ textTransform: 'uppercase', marginBottom: '.75rem' }}>
                          {asset.name}
                        </CardTitle>

                        {JwtStore.hasGlobalVisibility() && pfGroup.visibleOnlyForOutlets ? <OutletOnlyLabel /> : null}

                        <ThemeCardThemeStatus
                          small
                          status={asset.viewed === 0 ? ThemeStatusTypes.THEME_STATUS_NEW : ThemeStatusTypes.THEME_STATUS_COMPLETED}
                        />
                      </Card>
                    ))}
                  </PatternCardList>
                </div>
              </React.Fragment>
            ))}
          </ContainerInner>
        </Container>

        {this.state.thronModalOpened === true && this.state.assetClicked.contentType.toUpperCase() === 'OTHER' &&
            (
            ReactDOM.createPortal(
              <PDFModal
                style={{ zIndex: 1000 /* GlossaryModal is 999 */, }}
                onCloseButtonClick={() => this.setState({ thronModalOpened: false, assetClicked: null})}
                asset={this.state.assetClicked}
                isMobile={this.props.theme.isMobile} />,
              window.document.body,
            )
          )}
        {this.state.thronModalOpened === true && this.state.assetClicked.contentType.toUpperCase() !== 'OTHER' &&
         (
          ReactDOM.createPortal(
            <ThronAssetModal
              style={{ zIndex: 1000 /* GlossaryModal is 999 */, }}
              onCloseButtonClick={() => this.setState({ thronModalOpened: false, assetClicked: null})}
              options={{
                id: this.state.assetClicked.contentId,
                pKey: this.state.assetClicked.pKey,
              }} />,
            window.document.body,
          )
        )}
      </div>
    );
  }
}

export default withTheme(ProductFocusGroups);

const Container = styled.div`
  flex: 1;
  padding-top: ${themeResponsiveProperty('.75rem', '2.75rem')};
  padding-bottom: .75rem;
  background-color: ${themeResponsiveProperty(null, props => props.theme.primaryBackgroundColorNegative)};
`;

const ContainerInner = styled.div`
  max-width: 64rem;
  margin-left: auto;
  margin-right: auto;
`;

const ImageOverlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 0;
  opacity: ${themeResponsiveProperty('.3', null)};
`;

const SectionTitle = styled.h3`
  margin: 0;
  padding-right: ${themeResponsiveProperty('1rem', null)};
  padding-left: ${themeResponsiveProperty('1rem', null)};
  font-weight: bold;

  color: ${themeResponsiveProperty(null, '#fff')};

  ${themeResponsiveProperty(null, css`
    max-width: 47.5rem;
    margin-right: auto;
    margin-left: auto;
  `)};
`;
